export default "__VITE_ASSET__CspIy6Tq__"